import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=739b86bb&scoped=true&"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=739b86bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b86bb",
  null
  
)

export default component.exports